import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { BrowserFailDialog } from './dialogs/browser-fail-dialog/browser-fail-dialog';
import { DataService } from './shared/dataservice.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';

  isChrome: boolean = !!window['chrome'];
  extraErrorMessage = 'loading...';
  errorCount: number = 0;
  redirUrl:string;

  public options = {
    position: ["top", "right"],
    timeOut: 5000,
    lastOnBottom: true,
    showProgressBar: true,
    clickToClose: true
  };
  constructor(private router: Router, private dialog: MatDialog, private activeRoute: ActivatedRoute, public _dataService: DataService) {

  }

  ngOnInit() {
    if (this.isChrome == false) {
      this.dialog.open(BrowserFailDialog, {
        width: '50%'
      });
    }
    this.activeRoute.queryParams.subscribe((_params) => {
      this.redirUrl = _params['rurl'];
    });

    this.initApp();
    this.checkLoadErrors();
    // this.checkLoadErrorsPR();
  }
  
  private checkLoadErrors(){
    setTimeout(() => {
      if(this._dataService.isUnitDataLoaded == false || this._dataService.getCachedAllSaleOrders(1) == null){
        this.errorCount++;
        if(this.errorCount == 1)
          this.extraErrorMessage = "still loading...";
        else if(this.errorCount == 2)
          this.extraErrorMessage = "this is taking longer...";
        else if(this.errorCount == 3)
          this.extraErrorMessage = "try reloading the page...";
        else  
          return;
        
        this.checkLoadErrors();
      }
    }, 3000);
  }

  private checkLoadErrorsPR(){
    setTimeout(() => {
      if(this._dataService.isUnitDataLoaded == false || this._dataService.getCachedAllSaleOrdersPR(1) == null){
        this.errorCount++;
        if(this.errorCount == 1)
          this.extraErrorMessage = "still loading...";
        else if(this.errorCount == 2)
          this.extraErrorMessage = "this is taking longer...";
        else if(this.errorCount == 3)
          this.extraErrorMessage = "try reloading the page...";
        else  
          return;
        
        this.checkLoadErrorsPR();
      }
    }, 3000);
  }

  isLoadingDone():boolean{
    // return !(this._dataService.isUnitDataLoaded == false || this._dataService.getCachedAllSaleOrders(1) == null || this._dataService.getCachedAllSaleOrdersPR(1) == null);
    return !(this._dataService.isUnitDataLoaded == false || this._dataService.getCachedAllSaleOrders(1) == null);
  }
  
  private initApp() {
    this._dataService.getDataDefinitions().subscribe((_RetVal: boolean) => {
      if (_RetVal == false) {
        setTimeout(() => {
          this.initApp();
        }, 100);
      }
      else {
        this.preloadDataApp();
        // this.preloadDataAppPR();
      }
    });
  }

  private preloadDataApp() {
    this._dataService.getAllSalesOrder(1).subscribe((_RetVal) => {
      if (_RetVal == null || _RetVal.length == 0) {
        setTimeout(() => {
          this.preloadDataApp();
        }, 100);
      }
      else {
        if (this.redirUrl) {
          this.router.navigate([this.redirUrl]);
        }
        else {
          this.router.navigate(['/']);
        }
      }
    });
  }

  private preloadDataAppPR() {
    this._dataService.getAllSalesOrder_PR(1).subscribe((_RetVal) => {
      if (_RetVal == null || _RetVal.length == 0) {
        setTimeout(() => {
          this.preloadDataAppPR();
        }, 100);
      }
      else {
        if (this.redirUrl) {
          this.router.navigate([this.redirUrl]);
        }
        else {
          this.router.navigate(['/']);
        }
      }
    });
  }

  private preloadDataApp_2() {
    this._dataService.getAllSalesOrder_2(0).subscribe((_RetVal) => {
      if (_RetVal == null || _RetVal.length == 0) {
        setTimeout(() => {
          this.preloadDataApp_2();
        }, 100);
      }
      else {
        if (this.redirUrl) {
          this.router.navigate([this.redirUrl]);
        }
        else {
          this.router.navigate(['/']);
        }
      }
    });
  }
  onRightClick(dummy) {

  }

}
